module.exports = __webpack_public_path__ + "static/img/biankuang06.04d65c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang06.png
// module id = MQoB
// module chunks = 1